// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
Vue.config.productionTip = false
import moment from 'moment'
Vue.filter('dateFmt', function (input, fmtString) {
  return moment(input).format(fmtString)
})
import { Popup, Toast } from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.component(Popup.name, Popup);
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import hljs from 'highlight.js';
Vue.use(hljs);
Vue.directive('highlight', (el) => {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    let ol = document.createElement("ol");
    let rowCount = block.outerHTML.split('\n').length;
    for(let i=1;i < rowCount;i++){
      let li = document.createElement("li");
      let text = document.createTextNode(i);
      li.appendChild(text);
      ol.appendChild(li);
    }
    ol.className = 'pre-numbering';
    block.parentNode.appendChild(ol);
    let button = document.createElement("button");
    button.className = 'copy-button am-icon-copy';
    button.addEventListener('click', function(e) {
      vue.$copyText(e.target.parentNode.firstElementChild.textContent).then(() => {
        Toast('复制成功！')
      }, () => {
        Toast('复制失败！')
      })
    })
    block.parentNode.appendChild(button);
    hljs.highlightBlock(block)
  })
})
/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js